export var TypeActionLeagueInfo;
(function (TypeActionLeagueInfo) {
    TypeActionLeagueInfo["Received"] = "LeagueInfo > Received";
    TypeActionLeagueInfo["AddPoints"] = "LeagueInfo > AddPoints";
    TypeActionLeagueInfo["SetPoints"] = "LeagueInfo > SetPoints";
    TypeActionLeagueInfo["SelectLeague"] = "LeagueInfo > SelectLeague";
    TypeActionLeagueInfo["DeselectLeague"] = "LeagueInfo > DeselectLeague";
})(TypeActionLeagueInfo || (TypeActionLeagueInfo = {}));
export var actionPlayerLeagueInfo = function (props, leagueId) { return ({
    leagueId: leagueId,
    leagueInfo: props,
    type: TypeActionLeagueInfo.Received,
}); };
export var actionPlayerLeagueInfoAddPoints = function (points, leagueId) { return ({
    leagueId: leagueId,
    points: points,
    type: TypeActionLeagueInfo.AddPoints,
}); };
export var actionPlayerLeagueInfoSetPoints = function (points, leagueId) { return ({
    leagueId: leagueId,
    points: points,
    type: TypeActionLeagueInfo.SetPoints,
}); };
export var actionPlayerLeagueSelectLeague = function (leagueId) { return ({
    leagueId: leagueId,
    type: TypeActionLeagueInfo.SelectLeague,
}); };
export var actionPlayerLeagueDeselectLeague = function () { return ({
    type: TypeActionLeagueInfo.DeselectLeague,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/info/league/actionPlayerLeagueInfo.ts
// module id = 152
// module chunks = 3